<template>
  <a :class="badgeClass" :href="href" :target="target" @click.prevent="goto">
    <font-awesome-icon :icon="icon" />
    {{ theJobNumber }}

    <template v-if="openNew">
      <font-awesome-icon :icon="['fal', 'share-square']" />
    </template>
    <template v-else-if="entityId">
      <font-awesome-icon :icon="['fal', 'play']" />
    </template>
  </a>
</template>

<script type="text/babel">
export default {
  props: {
    jobNumber: {
      type: [Number, String],
      required: true,
    },

    entityId: {
      type: [Number, String],
    },
    openNew: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  data() {
    return {
      color: "badge-primary",
      icon: ["fal", "briefcase"],
    };
  },

  computed: {
    href() {
      return this.entityId ? `/jobs/${this.entityId}/edit` : false;
    },
    target() {
      return this.entityId && this.openNew ? "_blank" : false;
    },
    theJobNumber() {
      const jobNumber = `0${this.jobNumber}`.replace(/^0+/, "");

      return `${jobNumber}J`;
    },
    badgeClass() {
      return `badge badge-readable ${this.color} ${this.size}`;
    },
  },

  methods: {
    goto() {
      if (!this.entityId) {
        return;
      }

      if (this.openNew) {
        window.open(this.href);
      } else {
        this.$router.push({
          name: "jobs.edit",
          params: { id: this.entityId },
        });
      }
    },
  },
};
</script>
